import { toast } from 'sonner';

const DEFAULT_TIMEOUT = 5000;
const FALLBACK_MESSAGES = {
  info: 'Informasi',
  success: 'Sukses',
  warning: 'Peringatan',
  error: 'Gagal',
  primary: 'Informasi',
  secondary: 'Informasi',
};

const getToastText = (value) => {
  if (value == null || typeof value === 'boolean') {
    return undefined;
  }

  if (typeof value === 'string') {
    return value.trim() || undefined;
  }

  if (typeof value === 'number' || typeof value === 'bigint') {
    return String(value);
  }

  if (value instanceof Error) {
    return getToastText(value.message);
  }

  if (Array.isArray(value)) {
    return value.map(getToastText).filter(Boolean).join('\n') || undefined;
  }

  if (typeof value === 'object') {
    return getToastText(value.message ?? value.title ?? value.error);
  }

  return undefined;
};

const buildOptions = (description, timeOut) => ({
  description,
  duration: timeOut === 0 ? Infinity : timeOut || DEFAULT_TIMEOUT,
});

const showToast = (type, message, title, timeOut) => {
  const messageText = getToastText(message);
  const titleText = getToastText(title);
  const toastText = messageText || titleText || FALLBACK_MESSAGES[type];
  const description = messageText && titleText && messageText !== titleText ? titleText : undefined;
  const toastMethod = type === 'primary' || type === 'secondary' ? toast : toast[type];

  return toastMethod(toastText, buildOptions(description, timeOut));
};

const NotificationManager = {
  create(notify) {
    const notification = notify && typeof notify === 'object' ? notify : {};
    const { type = 'info', title = null, message = null, timeOut = DEFAULT_TIMEOUT } = notification;
    const supportedTypes = ['info', 'success', 'warning', 'error', 'primary', 'secondary'];
    const fn = supportedTypes.includes(type) ? NotificationManager[type] : NotificationManager.info;
    fn(message, title, timeOut);
  },

  info(message, title, timeOut) {
    return showToast('info', message, title, timeOut);
  },

  success(message, title = '', timeOut) {
    return showToast('success', message, title, timeOut);
  },

  warning(message, title, timeOut) {
    return showToast('warning', message, title, timeOut);
  },

  error(message, title, timeOut) {
    return showToast('error', message, title, timeOut);
  },

  primary(message, title, timeOut) {
    return showToast('primary', message, title, timeOut);
  },

  secondary(message, title, timeOut) {
    return showToast('secondary', message, title, timeOut);
  },

  remove() {},
};

export default NotificationManager;
